import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Edit2, Database, FlaskConical, Printer, Archive, ArrowLeft, Check } from 'lucide-react';

const WineToolbar = ({ 
    wine,
    onEdit,
    onShowContainer,
    onShowAnalysis,
    onPrintLabels,
    onToggleActive,
    onMarkTopped 
}) => {
    const navigate = useNavigate();
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {/*<h5 className="mb-0 me-3">
                            {wine?.varietal} {wine?.vintage}
                        </h5>*/}
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onEdit}
                                title="Edit Wine"
                            >
                                <Edit2 size={18} />
                            </button>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onShowContainer}
                                title="Add Container"
                            >
                                <Database size={18} />
                            </button>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={onShowAnalysis}
                                title="Add Analysis"
                            >
                                <FlaskConical size={18} />
                            </button>
                            <button
                                className="btn btn-outline-success btn-sm"
                                onClick={onMarkTopped}
                                title="Mark as Topped"
                            >
                                <Check className="me-1" />
                                Mark Topped
                            </button>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onPrintLabels}
                                title="Print Barrel Labels"
                            >
                                <Printer size={18} />
                            </button>
                        </div>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        {/*<div className="me-3">
                            <strong>Lot ID: </strong>{wine?.wineID}
                        </div>*/}
                        <div className="btn-group">
                             <button 
                                className="btn btn-outline-secondary"
                                onClick={() => navigate(-1)}
                                title="Back to List"
                            >
                                <ArrowLeft size={18} />
                            </button>
                            <button
                                className={`btn ${wine?.active ? 'btn-outline-secondary' : 'btn-secondary'}`}
                                onClick={onToggleActive}
                                title={wine?.active ? 'Archive Wine' : 'Unarchive Wine'}
                            >
                                <Archive size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .sticky-toolbar {
                    position: sticky;
                    top: 0;
                    background-color: #f8f9fa;
                    border-bottom: 1px solid #dee2e6;
                    padding: 0.5rem 1rem;
                    z-index: 1020;
                    margin-left: 250px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }

                @media (max-width: 991.98px) {
                    .sticky-toolbar {
                        margin-left: 0;
                        padding-left: 3.5rem; /* Space for mobile toggle button */
                    }
                }

                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default WineToolbar;